(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function ResourcesFilters(elem) {
        Behaviors.init(ResourcesFilters, this, arguments);

        var $thisElem = this.$elem,
            dropdown = $thisElem.find('.NF-Dropdown');

        // Shop Filters
        function Filters(paged, scroll = false) {
            var scrollOffset = $thisElem.offset().top - $('header').outerHeight() - 40,
                loop = $thisElem.find('.ResourcesFilters-loop-wrap');

            var queriedObjectId = $thisElem.data('queried-object-id');

            var topics = '';
            $thisElem.find('.ResourcesFilters-topic--active').each(function() {
                topics += topics.length > 0 ? ',' : '';
                topics += $(this).data('filter');
            });

            // Get search term
            var searchTerm = $thisElem.find('.NF-Search input').val();

            var category = $thisElem.data('default-category');

            $.ajax({
                url: theme_ajax_url, // AJAX handler
                data: {
                    'action': 'resources_filters',
                    paged: paged,
                    category: category,
                    topics: topics,
                    queriedObjectId: queriedObjectId,
                    searchTerm: searchTerm
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    $thisElem.addClass('NF--loading');
                },
                success: function (data) {

                    loop.html(data);

                    $thisElem.removeClass('NF--loading');

                    if (topics || searchTerm) {
                        $thisElem.find('.NF-clear-filters').addClass('NF-clear-filters--show');
                    } else {
                        $thisElem.find('.NF-clear-filters').removeClass('NF-clear-filters--show');
                    }

                    if (scroll) {
                        $('html, body').animate({
                            'scrollTop': scrollOffset
                        }, 500);
                    }

                }
            });
            return false;
        }

        // Pagination
        $(document).on("click", '.ResourcesFilters .NF-NumberPagination a', function (e) {
            e.preventDefault();

            var $this = $(this),
                paged = $(this).text(),
                current = parseInt($thisElem.find('.NF-NumberPagination .current').text());

            if ($this.hasClass('prev')) {
                paged = parseInt(current - 1);
            } else if ($this.hasClass('next')) {
                paged = parseInt(current + 1);
            }

            Filters(paged, true);
        });

        // Search
        $thisElem.find('.NF-Search form').on('submit', function (e) {
            e.preventDefault();

            Filters(1);
        });

        // Topics Dropdown
        dropdown.find('.NF-Dropdown-button').on('click', function (e) {
            e.stopPropagation();
            var $parent = $(this).parent();
            if ($parent.hasClass('open')) {
                $parent.removeClass('open');
            } else {
                $thisElem.find('.NF-Dropdown-button').removeClass('open');
                $parent.addClass('open');
            }
        });

        dropdown.find('.NF-Dropdown-menu').on('click', function (e) {
            e.stopPropagation();
        });

        dropdown.find('.NF-Dropdown-menu li a').on('click', function (e) {
            // var dropdownButtonText = $(this).text();
            dropdown.removeClass('open');
            // dropdown.find('.NF-Dropdown-text').text(dropdownButtonText);
        });

        $('html, body').on('click', function (e) {
            dropdown.removeClass('open');
        });

        // Topics Filter
        $thisElem.find('.ResourcesFilters-topic').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);

            if ($this.hasClass('ResourcesFilters-topic--active')) {
                $this.removeClass('ResourcesFilters-topic--active');
            } else {
                $this.addClass('ResourcesFilters-topic--active');
            }

            Filters(1);
        });

        // Clear Filters
        $thisElem.find('.NF-clear-filters').on('click', function (e) {
            e.preventDefault();

            $thisElem.find('.ResourcesFilters-topic').removeClass('ResourcesFilters-topic--active');

            dropdown.find('.NF-Dropdown-text').text(dropdown.find('.NF-Dropdown-text').data('default-label'));

            $thisElem.find('.NF-Search input').val('');

            Filters(1);
        });
    }

    Behaviors.inherit(ResourcesFilters, Behaviors.Behavior);

    ResourcesFilters.QUERY = "[data-resource-filters]";

    Behaviors.register_behavior(ResourcesFilters);

    module.ResourcesFilters = ResourcesFilters;

    return module;

}(window.jQuery, window.Behaviors));